// extracted by mini-css-extract-plugin
export default {"RegisterImage":"RegisterLogo_RegisterImage__rROwN"};